'use client';

import React from 'react';
import TopSearchBar from '@/components/TopSearchBar';
import BottomNav from '@/components/BottomNav';
import RequestsContent from '@/app/requests/components/RequestsContent';

export default function RequestsPage() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--background)' }}>
      <TopSearchBar />
      <main className="pb-24">
        <RequestsContent />
      </main>
      <BottomNav />
    </div>
  );
}
